var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.5a1 1 0 011-1h4a1 1 0 011 1v17a1 1 0 01-1 1H5a1 1 0 01-1-1v-17zM14 3.5a1 1 0 011-1h4a1 1 0 011 1v17a1 1 0 01-1 1h-4a1 1 0 01-1-1v-17z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMy41QzQgMi45NDc3MSA0LjQ0NzcyIDIuNSA1IDIuNUg5QzkuNTUyMjggMi41IDEwIDIuOTQ3NzIgMTAgMy41VjIwLjVDMTAgMjEuMDUyMyA5LjU1MjI4IDIxLjUgOSAyMS41SDVDNC40NDc3MiAyMS41IDQgMjEuMDUyMyA0IDIwLjVWMy41WiIgZmlsbD0iY3VycmVudCIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMy41QzE0IDIuOTQ3NzEgMTQuNDQ3NyAyLjUgMTUgMi41SDE5QzE5LjU1MjMgMi41IDIwIDIuOTQ3NzIgMjAgMy41VjIwLjVDMjAgMjEuMDUyMyAxOS41NTIzIDIxLjUgMTkgMjEuNUgxNUMxNC40NDc3IDIxLjUgMTQgMjEuMDUyMyAxNCAyMC41VjMuNVoiIGZpbGw9ImN1cnJlbnQiIHN0cm9rZT0iY3VycmVudCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgPause as ReactComponent };